module.exports = __webpack_public_path__ + "img/application.c8668764.svg";